class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('#predictive-search');
    this.primaryButton = this.querySelector('button[type="submit"]');
    this.isOpen = false;

    // SAFETY CHECK: If required elements don't exist, stop.
    if (!this.input || !this.results) {
      console.warn('PredictiveSearch: Search elements not found — script disabled.');
      return;
    }

    this.input.addEventListener('input', this.onChange.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    if (this.primaryButton) {
      this.primaryButton.addEventListener('click', this.onSubmit.bind(this));
    }

    document.addEventListener('click', this.onBodyClick.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  onFocus() {
    const searchTerm = this.input.value.trim();
    if (searchTerm.length) this.getSearchResults(searchTerm);
  }

  onSubmit(event) {
    if (!this.isOpen) return;
    event.preventDefault();
    const firstItem = this.results.querySelector('a');
    if (firstItem) window.location = firstItem.href;
  }

  getSearchResults(searchTerm) {
    const cached = this.cachedResults[searchTerm];
    if (cached) {
      this.renderSearchResults(cached);
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`)
      .then((response) => response.json())
      .then((result) => {
        this.cachedResults[searchTerm] = result;
        this.renderSearchResults(result);
      })
      .catch(() => {
        this.close();
      });
  }

  renderSearchResults(results) {
    if (!results.resources) {
      this.close();
      return;
    }

    this.results.innerHTML = this.buildResultsHTML(results.resources);
    this.open();
  }

  buildResultsHTML(resources) {
    let html = '';

    if (resources.products && resources.products.length > 0) {
      html += `
        <div class="predictive-search-products">
          <h3>Products</h3>
          <ul>
            ${resources.products
              .map(
                (product) => `
                <li>
                  <a href="${product.url}">
                    <img src="${product.featured_image.url}" alt="${product.title}">
                    ${product.title}
                  </a>
                </li>`
              )
              .join('')}
          </ul>
        </div>`;
    }

    return html;
  }

  open() {
    if (this.isOpen || !this.results) return;
    this.results.classList.remove('hidden');
    this.isOpen = true;
  }

  close() {
    if (!this.results) return;
    this.results.classList.add('hidden');
    this.isOpen = false;
  }

  onBodyClick(event) {
    if (!this.input) return;
    if (event.target === this.input || this.contains(event.target)) return;
    this.close();
  }
}

customElements.define('predictive-search', PredictiveSearch);
